// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExpenseReport  {
    _originalTypeClassName = "Loom.BO.ExpenseReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExpenseReport.translate = translateService;
}
this.Expenses = [];
this.Id = null;
this.AuthorizedFinance = false;
this.TotalAmountEUR = null;
this.EmployeeAmountEUR = null;
this.ChargeableToProject = false;
this.Reimbursed = false;
this.ReimbursedOn = null;
this.CreatedOn = null;
this.Status = null;
this.RejectionReason = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
AuthorizedFinance:any;
TotalAmountEUR:any;
EmployeeAmountEUR:any;
ChargeableToProject:any;
Reimbursed:any;
ReimbursedOn:any;
CreatedOn:any;
Status:any;
RejectionReason:any;
Expenses:any;
Person:any;
Trip:any;
static setExpenses = ($this, items) => {
                if (items == null) items = [];
                if ($this.Expenses == null) $this.Expenses = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Expenses.length > 0) {
                    Domain.ExpenseReport.removeExpenses($this, $this.Expenses[0]);
                }

                Domain.ExpenseReport.addManyExpenses($this, copyItems);
            }
static addManyExpenses = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ExpenseReport.addExpenses($this, items[i]);
                }
            }
static addExpenses = ($this, item) => {
                if ($this.Expenses == null) $this.Expenses = [];
                if (item == null || $this.Expenses.indexOf(item) > -1) return;
                $this.Expenses.push(item);
if (item.ExpenseReport != $this) {
Domain.ExpenseReportDetail.setExpenseReport(item, $this);
}
}
static addRangeExpenses = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ExpenseReport.addExpenses($this, item));
            }
static removeExpenses = ($this, item) => {
                if ($this == null || $this.Expenses == null || $this.Expenses.indexOf(item) === -1) return;
                var _index = $this.Expenses.indexOf(item);
                $this.Expenses.splice(_index, 1);
item.ExpenseReport = null;
}
static clearExpenses = ($this) => { $this.Expenses = null; }
static setPerson = ($this, value) => {
var oldValue = $this.Person;
$this.Person = value;
if (value != null) {
}
}
static setTrip = ($this, value) => {
var oldValue = $this.Trip;
$this.Trip = value;
if (value != null) {
if (oldValue != null) {
Domain.Trip.removeExpenseReports(oldValue, $this);
}
Domain.Trip.addExpenseReports(value, $this);
}
}

static GetEmployeeAmountEUR($this: any): any{return $this?.Expenses?.linq?.where((a) => !(a?.PaidByTheCompany) && a?.Reimbursable)?.toArray()?.linq?.sum((a) => a?.AmountEUR);
}
static GetTotalAmountEUR($this: any): any{return $this?.Expenses?.linq?.sum((a) => a?.AmountEUR);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}